import React from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow
} from '@/components/ui/table';
import { Plus, Trash2, User } from 'lucide-react';

// Status History Tab — read-only log of every status transition for this load.
// Pure presentational component: parent owns the data + mutation callbacks.
export const StatusHistoryTab = ({
  statusHistory,
  formData,
  onChangeStatus,
  onDeleteEntry,
  formatDateTime,
}) => (
  <div className="space-y-4">
    <div className="flex items-center gap-3">
      <Button
        size="sm"
        className="bg-orange-500 hover:bg-orange-400"
        onClick={onChangeStatus}
        data-testid="change-status-btn"
      >
        <Plus className="h-4 w-4 mr-1" />Change Status
      </Button>
      <div className="flex items-center gap-2 text-sm text-slate-400">
        <span>Current:</span>
        <Badge variant="outline" className="text-white">{formData.status}</Badge>
        {formData.driver_name && (
          <>
            <User className="h-4 w-4 ml-2" />
            <span>{formData.driver_name}</span>
          </>
        )}
      </div>
    </div>

    <Table className="data-table">
      <TableHeader>
        <TableRow className="border-slate-800">
          <TableHead className="text-slate-400">Status</TableHead>
          <TableHead className="text-slate-400">Event TimeStamp</TableHead>
          <TableHead className="text-slate-400">Effective Date</TableHead>
          <TableHead className="text-slate-400">Driver</TableHead>
          <TableHead className="text-slate-400">Message</TableHead>
          <TableHead className="text-slate-400">Action</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {statusHistory.map(entry => (
          <TableRow key={entry.id} className="border-slate-800">
            <TableCell className="text-white">{entry.status}</TableCell>
            <TableCell className="text-slate-300 text-xs">{formatDateTime(entry.created_at)}</TableCell>
            <TableCell className="text-slate-300">{entry.effective_date || '-'}</TableCell>
            <TableCell className="text-slate-300">{entry.driver_name || '-'}</TableCell>
            <TableCell className="text-slate-300">{entry.message || '-'}</TableCell>
            <TableCell>
              <Button
                variant="ghost"
                size="icon"
                className="h-6 w-6 text-slate-400 hover:text-red-400"
                onClick={() => onDeleteEntry(entry.id)}
              >
                <Trash2 className="h-3 w-3" />
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
    <p className="text-sm text-slate-500">Total {statusHistory.length} records listed</p>
  </div>
);
